import { render, staticRenderFns } from "./EditCourseModal.vue?vue&type=template&id=27b26b8c&scoped=true&"
import script from "./EditCourseModal.vue?vue&type=script&lang=ts&"
export * from "./EditCourseModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b26b8c",
  null
  
)

export default component.exports